import React from "react";
import { LOCALE_STRINGS } from "constants/locales";

const RefreshIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 10D17.5 5.5 13 4 8 5M4 14D6.5 18.5 11 20 16 19"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M20 4V10H14"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 20V14H10"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShieldCheckIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CalendarCheckIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2V6M8 2V6M3 10H21"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 15L11 16.5L14.5 13"
      stroke="#008CB7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThreeCardFeatureSection = ({ language = "EN" }) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};

  const cardsData = [
    {
      icon: <RefreshIcon />,
      title:
        strings.three_card_1_title ||
        "Trade in your own currency",
      desc:
        strings.three_card_1_desc ||
        "Importers and exporters transact in their preferred local currencies, eliminating the friction and cost of forced conversions on every trade.",
    },
    {
      icon: <ShieldCheckIcon />,
      title:
        strings.three_card_2_title ||
        "Regulated without the overhead",
      desc:
        strings.three_card_2_desc ||
        "Fully regulated processing through licensed partners ensures AML and KYC compliance runs in the background, not as extra work on your side.",
    },
    {
      icon: <CalendarCheckIcon />,
      title:
        strings.three_card_3_title ||
        "Settlement you can plan around",
      desc:
        strings.three_card_3_desc ||
        "Faster settlement and lower transaction costs add up to cash flow that's predictable for every party in the chain — no more guessing when funds land.",
    },
  ];

  return (
    <section className="three-card-feature-section">
      <div className="three-card-feature-list">
        {cardsData.map((card, index) => (
          <div key={index} className="three-card-feature-item">
            <div className="three-card-feature-icon-wrapper">
              {card.icon}
            </div>

            <div className="three-card-feature-content">
              <h3 className="three-card-feature-title">{card.title}</h3>
              <p className="three-card-feature-description">{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ThreeCardFeatureSection;